/**
 * Formats a US phone number string to (xxx) xxx-xxxx.
 * Used by utils/common (re-exported) and constants/common to avoid circular dependency.
 */
export const formatPhoneNumber = (phoneNumberString: string): string => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '')
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)

  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3]
  }

  return ''
}

// Formats to 855-284-7483 format (e.g. 8552847483)
export const formatPhoneNumberToDashedFormatString = (
  phone: string
): string => {
  // Return if already formatted or empty
  if (!phone || /^\d{3}-\d{3}-\d{4}$/.test(phone)) {
    return phone
  }

  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '')

  // Check if we have exactly 10 digits
  if (cleaned.length === 10) {
    return `${cleaned.slice(0, 3)}-${cleaned.slice(3, 6)}-${cleaned.slice(6)}`
  }

  // Return original if not 10 digits
  return phone
}
